module.exports = __webpack_public_path__ + "static/media/fractions-multiple-choice.363c0723.svg";